/* eslint-disable no-param-reassign */
import traverse from 'traverse';
import * as isSecret from 'is-secret';

const redactSecrets = (redacted, options) => {
  if (options === undefined) {
    options = {
      keys: [],
      values: [],
    };
  }
  const a = options.keys;
  const keys = a === undefined ? [] : a;
  const b = options.values;
  const values = b === undefined ? [] : b;
  const isRedactable = (key, value) => {
    const isGenericSecret = isSecret.key(key) || isSecret.value(value);
    const isUserSecret = keys.some(regex => regex.test(key)) || values.some(regex => regex.test(value));
    return isGenericSecret || isUserSecret;
  };
  const map = (obj) => {
    const updated = traverse.default(obj).map((val) => {
      if (isRedactable(this.key, val)) {
        return this.update(redacted);
      }
      return false;
    });
    return updated;
  };
  const forEach = (obj) => {
    traverse.default(obj).forEach((val) => {
      if (isRedactable(this.key, val)) {
        this.update(redacted);
      }
    });
  };
  return {
    map,
    forEach,
  };
};

export default redactSecrets;
